import React from 'react';
import "./applyButton.css";

function ApplyButton(props) {
    return (
        <a target="_blank" rel="noopener noreferrer" href={props.target_link}>
            <button type="button" className="custom-btn-n btn-14-n">{props.text}</button>
        </a>
    );
}

export default ApplyButton;
